export const ptActionType = {
    SET_TOTAL_PTS: 'SET_TOTAL_PTS',
    SET_TODAY_PTS: 'SET_TODAY_PTS',
    SET_THISWEEK_PTS: 'SET_THISWEEK_PTS',
}